import api from "../axios";

export const getEventDataApi = (data) => api.get(`event/${data}`, data);
export const ClientEventDetailsApi = (data) =>
  api.get(`user/eventDetails/${data}`, data);
export const getCategoryEvents = (data) =>
  api.post(`category/${data.category}`, data);
export const ClientUpcomingEvents = (data) =>
  api.get(`events/upcoming-events`, data);
export const CalenderDates = (data) => api.get(`events/calender-dates`, data);
export const WhereToEvents = (data) => api.get("/whereto/allevents", data);
export const AllDateEvents = (data) => api.post("/events/alldates", data);
export const GetTrendingEvents = (data) => api.get("/trending-events", data);
export const GetTestingEvents = (data) => api.get("/testing-events", data);
